module.exports = __webpack_public_path__ + "assets/img/ftr_youtube.webp?ddcbf010259fb9464f0c141608cdb8c5";